import { vuex as app } from 'src/app';

export default [...app.plugins];
